export function loading (state, value) {
  state.loading = !!value
}

export function setCategoriesOpen (state, value) {
  state.categoriesOpen = value
}

export function setCatalog (state, value) {
  state.catalog = value
}

export function setFilter (state, value) {
  state.filter = value
}
